import { typedFrontendVendorApi } from "@vendor-app/utils/typedFrontendVendorApi";

import { PriceChangesGatewayInterface } from "./PriceChangesGatewayInterface";
import { PriceChangeInterface } from "../domain/PriceChangeInterface";
import PriceChangesMapper from "../mappers/PriceChangesMapper";

export default class PriceChangesGateway implements PriceChangesGatewayInterface {
  constructor(private readonly mapper: PriceChangesMapper) {}

  public async fetch(pageNumber?: number): Promise<{ data: PriceChangeInterface[]; total: number }> {
    let data: PriceChangeInterface[] = [];
    let total = 0;

    try {
      const query = pageNumber === undefined ? {} : { pageNumber: String(pageNumber) };
      const response = await typedFrontendVendorApi.getReq("/price-changes", { query });

      if (response.type === "success") {
        data = this.mapper.map(response.body.priceChanges);
        total = response.body.total;
      }
    } catch (error) {
      console.error("Failed to fetch price changes:", error);
    }

    return { data, total };
  }

  public async fetchUnnotified(): Promise<PriceChangeInterface[]> {
    const response = await typedFrontendVendorApi.getReq("/price-changes/unnotified");

    if (response.type === "error") {
      throw new Error("Request to fetch unnotified price changes failed.");
    }

    return this.mapper.map(response.body.priceChanges) as PriceChangeInterface[];
  }

  public async notify(ids: string[]): Promise<void> {
    const response = await typedFrontendVendorApi.postReq("/price-changes/notify", {
      reqBody: {
        ids,
      },
    });

    if (response.type === "error") {
      throw new Error("Request to mark price changes as notified failed.");
    }
  }

  public async apply(uuid: string, notify: boolean, groupUuid?: string, totalExpected?: number): Promise<void> {
    const response = await typedFrontendVendorApi.postReq(`/price-changes/${uuid}/apply`, {
      reqBody: {
        notify,
        groupUuid,
        totalExpected,
      },
    });

    if (response.type === "error") {
      throw new Error("Request to apply price change failed.");
    }
  }

  public async dismiss(priceChangeId: string): Promise<void> {
    const response = await typedFrontendVendorApi.postReq(`/price-changes/${priceChangeId}/dismiss`);

    if (response.type === "error") {
      throw new Error("Request to dismiss price change failed.");
    }
  }
}
